import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {FormControl} from "@angular/forms";

@Component({
	templateUrl: './attach_tariff.component.html'
})
export class AttachTariffModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	i18nTariffs: any;
	tariffs: any[] = [];
	tariffsVariants: any[] = [];
	paymentType: number = 99;
	paymentId: string = '';
	dateToFilter: boolean = false;
	customDateTo: string = '';
	invoiceNumber: string = '';
	tariffId: string = '';
	transactionId: string = '';
	variantName: string = '';
	periodType: number = 1;
	customDaysCount: number = 1;
	amount: string = '';
	notFirstPayment: boolean = false;

	async ngOnInit() {
		this.spreader.base.form = this.form;

		this.form.addControl('customDateTo', new FormControl('', [
			this.getStandartValidator('customDateTo_format', this.CustomValidators.dateFormat('YYYY-MM-DD'), '"Вариант тарифа" - Неверный(YYYY-MM-DD) формат даты'),
			this.getStandartValidator('customDateTo_min', this.CustomValidators.dateNotBeforeToday('YYYY-MM-DD'), '"Вариант тарифа" - Дата не может быть меньше текущей'),
		]));
		
		this.i18nTariffs = this.supportService.i18nTariffs;
		this.tariffs = await this.supportService.getTariffs(this.siteId).toPromise();
		this.tariffId = this.tariffs[0]._id;

		this.updateVariants();
	}

	updateVariants() {
		this.tariffsVariants = this.tariffs.reduce((p, c) => {
			if(this.tariffId == c._id) {
				return c.variants;
			}
			
			return p;
		}, []);
		
		this.variantName = this.tariffsVariants.length > 0 ? this.tariffsVariants[0].name : '';
	}

	async getInvoiceInfo() {
		let data = await this.supportService.getInvoiceInfo(this.siteId, this.invoiceNumber).toPromise();

		if (data['invoiceId']) {
			if (data['totalConverted']) {
				this.amount = data['totalConverted'];
			} else {
				//nf.notify('totalConverted для инвойса #' + $tIdInput.val() + ' не найден');
				this.amount = '';
			}
			this.tariffId = data['tariffId'];
			this.variantName = data['tariffVariant'];
		} else {
			//nf.notify('Инвойс #' + $tIdInput.val() + ' не найден');
			this.amount = '';
		}
	}

	async ok() {
		if (confirm(`Вы уверены, что хотите назначить тариф сайту ${this.domainUrl}?`)) {
			await this.supportService.attachTariff(
				this.siteId, 
				this.tariffId, 
				this.variantName, 
				this.customDateTo,
				this.customDaysCount,
				this.periodType,
				this.invoiceNumber,
				this.amount,
				this.paymentType,
				this.paymentId,
				this.notFirstPayment, 
				this.spreader.base.comment
			).toPromise();
			
			this.execute();
		}
	}
}
